module.exports = __webpack_public_path__ + "static/img/case_detail_07_4.a126cce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_detail_07_4.png
// module id = lnwe
// module chunks = 34